<template>
  <div>
    <v-radio-group v-show="hideRadopButtons" mandatory v-model="transitionType" @change="changeTransition" row>
      <v-radio v-for="(item, index) in types" :key="index" color="var(--app-dark-blue-1)" :label="item.label"
        :value="item.value"></v-radio>
    </v-radio-group>
    <v-form lazy-validation ref="transitionForm">
      <div v-if="transitionType == 'url'">
        <v-text-field label="Ссылка" required type="text" outlined :rules="[
          (v) => !!v || 'Обязательно к заполнению',
          (v) => checkValidUrl(v) || '',
        ]" v-model="object.path"></v-text-field>
      </div>
      <div v-if="transitionType == 'deeplink'">
        <v-select :items="sections" outlined item-text="name" item-value="key"
          :rules="[(v) => !!(v && v.length) || 'Обязательно к заполнению']" v-model="object.appSectionKey" @change="changeAppSection"
          label="Выберите раздел для перехода"></v-select>
        <v-select v-if="selectedAppSectionKey == 'polls'" :items="polls" outlined item-text="title"
          item-value="id" v-model="object.path" label="Выберите раздел для перехода"></v-select>
        <v-autocomplete v-if="selectNewsItem && selectedAppSectionKey == 'news'" :items="news" outlined item-text="name"
          item-value="id" v-model="object.path" clearable
          label="Выберите новость"></v-autocomplete>
      </div>
      <div v-if="transitionType == 'page'">
        <v-select :items="pages" outlined item-text="title" item-value="id"
          :rules="[(v) => !!(v && v.length) || 'Обязательно к заполнению']" v-model="object.path"
          label="Выберите страницу"></v-select>
      </div>
      <div v-if="transitionType == 'file'">
        <v-file-input v-if="object.file == null || typeof object.file == 'object'" outlined show-size
          v-model="object.file" label="Прикрепите файл pdf" :rules="[
            (value) =>
              (value && value.size < 104857600) ||
              'Размер pdf не больше 100 мб',
          ]" hint="Максимальный размер pdf 100 Мб" persistent-hint accept="application/pdf,application/vnd.ms-excel">
        </v-file-input>

        <div v-else class="pdf-preview">
          <v-icon> mdi-file-pdf-box </v-icon>

          <a target="_blank" :href="object.file">PDF файл</a>

          <v-icon @click="deleteFile" style="margin-left: 20px" color="var(--app-red-1)">
            mdi-delete-outline
          </v-icon>
        </div>
      </div>
      <v-text-field v-if="buttonName" label="Название кнопки" required type="text" outlined
        v-model="object.buttonName"></v-text-field>
      <v-checkbox v-if="transitionType == 'url' && hideCheckBox" class="container-main-checkbox pt-5"
        color="var(--app-dark-blue-1)" v-model="object.isWebView"
        label="Открыть WebView (ссылка откроется внутри приложения)"></v-checkbox>
    </v-form>
  </div>
</template>
<script>

export default {
  props: {
    hideTypes: {
      type: Array,
      default() {
        return [];
      },
    },
    value: {},
    buttonName: { type: Boolean, default: false },
    hideCheckBox: { type: Boolean, default: true },
    hideRadopButtons: { type: Boolean, default: true },
    selectNewsItem: { type: Boolean, default: false },
  },
  data: () => ({
    transitionType: null,
    selectedAppSectionKey: null,
    object: {
      path: "",
      isWebView: false,
      file: null,
      appSectionKey: null,
      type: null,
    },
    pages: [],
    sections: [],
    polls: [],
    news: [],
    types: [
      {
        label: "Нет перехода",
        value: "null",
      },
      {
        label: "Ссылка",
        value: "url",
      },
      {
        label: "Внутренний раздел",
        value: "deeplink",
      },
      {
        label: "Страница",
        value: "page",
      },
      {
        label: "PDF Файл",
        value: "file",
      },
    ],
  }),
  methods: {
    validMethod() {
      if (this.$refs.transitionForm.validate()) {
        return true;
      } else {
        return false;
      }
    },
    changeTransition() {
      this.object.type = this.transitionType;
      this.object.path = null;
      this.object.appSectionKey = null;
      this.selectedAppSectionKey = null;
      this.object.file = null;
      this.object.isWebView = false;
    },

    normalizeAppSectionKey(value = this.object.appSectionKey) {
      const section = this.sections.find((item) => {
        return item.key === value || item.id === value || item.name === value;
      });
      return section ? section.key : value;
    },
    setSelectedAppSectionKey(value = this.object.appSectionKey) {
      const key = this.normalizeAppSectionKey(value);
      this.selectedAppSectionKey = key || null;
      if (this.object.appSectionKey && key && this.object.appSectionKey !== key) {
        this.object.appSectionKey = key;
      }
    },
    changeAppSection(value) {
      this.object.path = null;
      this.setSelectedAppSectionKey(value);
      this.ensureAppSectionData();
    },
    ensureAppSectionData() {
      this.setSelectedAppSectionKey();
      if (this.selectedAppSectionKey == "polls") {
        this.getPolls();
      }
      if (this.selectNewsItem && this.selectedAppSectionKey == "news") {
        this.getNews();
      }
    },
    getPolls() {
      this.$axios
        .get(
          this.$store.getters.apiAdminPanelV3 + "/poll/list",

          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
            },
          }
        )
        .then((res) => {
          this.polls = res.data;
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    getNews() {
      this.$axios
        .post(
          this.$store.getters.apiAdminPanelV2 + "/news/list",
          {},
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
            },
          }
        )
        .then((res) => {
          this.news = res.data.items;
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    getPages() {
      this.$axios
        .post(
          this.$store.getters.apiAdminPanelV2 + "/page/list",
          {},
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
            },
          }
        )
        .then((res) => {
          this.pages = res.data.items;
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    getAppSections() {
      this.$axios
        .post(
          this.$store.getters.apiAdminPanelV2 + "/appSection/list",
          {},
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
            },
          }
        )
        .then((res) => {
          this.sections = res.data.items.filter((i) => {
            if (!i.isRemovable) {
              return i;
            }
          });
          this.ensureAppSectionData();
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    deleteFile() {
      this.object = { ...this.object, file: null };
    },
  },
  created() {
    this.getPages();
    this.getAppSections();

    this.types = this.types.filter((i) => {
      if (this.hideTypes.length > 0) {
        if (!this.hideTypes.includes(i.value)) {
          return i;
        }
      } else {
        return i;
      }
    });
  },
  mounted() {
    if (this.value && (this.value.id || this.value.type)) {
      this.object = Object.assign({}, this.value);
      this.oldValue = Object.assign({}, this.value);
      this.transitionType = this.object.type;
      if (this.value.type == "file") {
        this.object.file = this.object.path;
      }
      this.ensureAppSectionData();
    }
  },
  watch: {
    object: {
      handler() {
        this.$emit("input", this.object);
      },
      deep: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.container-main-checkbox {
  border: 1px solid rgb(224, 224, 224);
  border-radius: 4px;
  padding-top: 20px;
  padding-left: 12px;
  margin-top: 0px !important;
}

.pdf-preview {
  margin-bottom: 24px;
}
</style>